"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let RechargeModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.coin = 0;
    this.coupon = 0;
    this.vdCard = 0;
    this.goods = new Array();
  }
};
RechargeModel.model = "recharge";
RechargeModel = __decorateClass([
  Annotation.ModelMeta
], RechargeModel);
export let ProductModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.present_count = 0;
    this.price = 0;
    this.spec_goods_number = 0;
    this.spec_name = "";
    this.type = "";
  }
};
ProductModel.model = "coin";
ProductModel = __decorateClass([
  Annotation.ModelMeta
], ProductModel);
export let GoldenBeanModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.comment = "";
    this.coins = 0;
    this.balance = 0;
    this.createdTime = 0;
    this.id = "";
    this.name = "";
    this.account_guid = "";
  }
};
GoldenBeanModel.model = "order";
GoldenBeanModel = __decorateClass([
  Annotation.ModelMeta
], GoldenBeanModel);
export let OrderModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.consume = "";
    this.guid = "";
    this.invoice_status_desc = "";
    this.operator_name = "";
    this.order_created_time = 0;
    this.order_no = "";
    this.pay_platform = "";
    this.should_pay_coin = 0;
    this.use_discount_coupon = false;
    this.should_pay_discount_coupon = null;
  }
};
OrderModel.model = "order";
OrderModel = __decorateClass([
  Annotation.ModelMeta
], OrderModel);
export let OrderVDModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.ip = "";
  }
};
OrderVDModel.model = "order";
OrderVDModel = __decorateClass([
  Annotation.ModelMeta
], OrderVDModel);
export let OrderAPPNumberModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.cloud_phone = "";
    this.cloud_phone_config = "";
    this.cloud_phone_time = "";
  }
};
OrderAPPNumberModel.model = "phone.info.model";
OrderAPPNumberModel = __decorateClass([
  Annotation.ModelMeta
], OrderAPPNumberModel);
export let PaidServiceModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
    this.cost = "";
    this.valid_date = "";
    this.expire_date = 0;
  }
};
PaidServiceModel.model = "paid.service";
PaidServiceModel = __decorateClass([
  Annotation.ModelMeta
], PaidServiceModel);
